import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Styles from './NextArticle.module.scss';
import RightArrow from '@hiredigital/ui/Icon/icons/right-arrow.inline.svg';
import Img from '@components/Img';
import router from 'next/router';

const NextArticle = forwardRef(({ data }, ref) => (
  <div ref={ref} className={Styles.card} onClick={() => router.push(data?.to || '/blog')}>
    <div className={Styles.header}>
      {`Read next`}
      <RightArrow />
    </div>
    {data?.featuredImage && (
      <Img src={data.featuredImage} className={Styles.featuredImage} width={75} height={75} />
    )}
    <h3 className={Styles.title}>{data?.title || 'Untitled'}</h3>
    {data?.tag && <div className={Styles.tag}>{data.tag}</div>}
  </div>
));

NextArticle.propTypes = {
  data: PropTypes.shape({
    featuredImage: PropTypes.string,
    title: PropTypes.string,
    tag: PropTypes.string,
    to: PropTypes.string,
  }),
};

export default NextArticle;
